import classNames from 'classnames';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import React from 'react';
import AdSense from 'react-adsense';
import { connect } from 'react-redux';
import Helper from '../../modules/Helper';
import CarCompanies from '../Car/CarCompanies';
import VertTitle from '../Common/VertTitle';
import SloganContainer from '../Flight/SloganContainer';
import MainLayout from '../Layouts/MainLayout';
import FilterForm from './FilterForm';

type CarsProps = {
	query?: any;
	dynamic?: boolean;
	useHeadline?: boolean;
	location?: string;
	brandsDescription?: string;
	page?: any;
	lng: string;
};
type CarsState = {
	isVan: boolean;
	vertTitle: string;
	description: string;
	h2description: string;
	metaDescription: string;
	cityTitle: string;
	isLocation: boolean;
	slogan: string;
	cityMetaDescription?: string;
	cityKeywords?: string;
	metaTitle: string;
	url: string;
	brandsDescription?: string;
	newsletterSlogan: string;
};

const NewsLetterForm = dynamic(() => import('../Flight/NewsLetterForm'), { ssr: true });

class Cars extends React.Component<CarsProps, CarsState> {
	constructor(props: CarsProps) {
		super(props);
		this.state = {
			isVan: false,
			vertTitle: 'mainArea.cars.title',
			description: ``,
			h2description: ``,
			cityTitle: ``,
			isLocation: false,
			slogan: `main.cars.verticalSlogan`,
			metaTitle: props.page?.title || 'Cars lowest prices',
			metaDescription:
				props.page?.metaDescription ||
				"We search Car and travel booking sites across the web to find the world's lowest prices",
			url: props.page
				? `https://travelpricedrops.com/cars/${props.page.slug}${props.page?.lng ? `?lng=${props.page.lng}` : ''}`
				: 'https://travelpricedrops.com/cars',
			newsletterSlogan: Helper.trans('main.cars.newsletterSlogan'),
		};
	}

	componentDidMount() {
		const parsed = this.props.query;

		if (this.props.dynamic) {
			const brand = parsed['theme'];
			if (brand) {
				this.setState({
					h2description: `Our algorithm compares ${brand} and other car rental sites to determine the best deal`,
				});
			}
		}

		if (parsed && parsed.hasOwnProperty('car-class')) {
			switch (parsed['car-class']) {
				case 'van':
					this.setState({ vertTitle: 'mainArea.cars.vanTitle' });
					break;
				case 'pickup':
					this.setState({ vertTitle: 'mainArea.cars.pickupTitle' });
					break;
				default:
					break;
			}
		}

		if (parsed && parsed.hasOwnProperty('pickup') && parsed.pickup === '1') {
			this.setState({ vertTitle: 'mainArea.cars.oneWayRentalTitle' });
		}

		if (this.props.page?.headingOne && this.props.page?.headingTwo) {
			this.setState({
				vertTitle: this.props.page.headingOne,
				brandsDescription: this.props.page.headingTwo,
			});
		}

		const texts = this.props.query?.texts;
		if (texts) {
			this.setState({
				metaDescription: texts.metaDescription,
				metaTitle: texts.metaTitle,
				vertTitle: texts.h1,
				brandsDescription: texts.h2,
				newsletterSlogan: texts.newsletter,
			});
		}
	}

	renderAdSense = () => {
		if (typeof window != 'undefined') {
			if (process.env.NEXT_PUBLIC_SHOW_PRODUCTION_SCRIPTS === 'true' && Helper.checkQueryStringKeyValue('ad', '1')) {
				return (
					<>
						<AdSense.Google
							client="ca-pub-2732183997877262"
							slot="2446285810"
							style={{ display: 'block' }}
							format="auto"
							responsive="true"
						/>
						<br />
					</>
				);
			}
		}
		return '';
	};

	render() {
		const isRtl = Helper.isRtlLanguage(this.props.lng);
		const isArabic = Helper.isArabicLanguage(this.props.lng);

		return (
			<MainLayout>
				<Head>
					<script
						type="application/ld+json"
						dangerouslySetInnerHTML={{
							__html: `
							{
									"@context": "http://schema.org",
									"@type": "Service",
									"name": "${this.state.metaTitle}",
									"description" : "${this.state.metaDescription}",
									"url" :"${this.state.url}",
									"image" : "https://travelpricedrops.com/images/block-background-cars.png"
							}`,
						}}
					/>
				</Head>
				<div
					id="main-area"
					className={classNames('cars-container', {
						rtl: isRtl,
						arabic: isArabic,
					})}
				>
					<div className="container">
						<div className="row justify-content-center align-items-center">
							<div className="cars-filter-form col-12">
								<div id="filter-form-wrapper" className="col-md">
									<VertTitle useHeadline={this.props.useHeadline} i18nKey={this.state.vertTitle} title={this.props.page?.h1} />
									<FilterForm />
								</div>
							</div>
						</div>
						<div className="row justify-content-between align-items-center">
							<div className="col-12 col-md-8 text-center m-auto">
								<CarCompanies
									page={this.props.page}
									description={
										this.state.brandsDescription
											? `${Helper.capitalize(this.state.brandsDescription)}`
											: this.state.h2description
									}
									dynamic={this.state.brandsDescription ? true : this.props.dynamic}
								/>
							</div>
						</div>
						<div className="clearfix" />
						<div className="d-xl-block d-none">
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
						</div>
					</div>
					<div className="curve-mask">
						<div className="curve-up" id="curve-3"></div>
					</div>
				</div>
				<SloganContainer
					isLocation={this.state.isLocation}
					vert="Cars"
					description={this.state.description}
					sloganKey={this.state.slogan}
					img="/images/world-map.png?v1.0"
				>
					{this.renderAdSense()}
				</SloganContainer>
				<NewsLetterForm>
					<h5
						dangerouslySetInnerHTML={{
							__html: this.state.newsletterSlogan,
						}}
					/>
				</NewsLetterForm>
			</MainLayout>
		);
	}
}

const mapStateToProps = (state: any) => ({
	lng: state.base.lng,
});

export default connect(mapStateToProps, {})(Cars);
